module.exports = __webpack_public_path__ + "img/1440946874.37e757b0.jpg";